import { create } from 'zustand';

/**
 * @typedef {{ id: string, type: 'success' | 'error' | 'info' | 'warning', message: string }} Toast
 */

export const useUiStore = create((set) => ({
  activeTab: 'feed',
  isMenuOpen: false,
  toasts: [],
  setActiveTab: (tab) => set({ activeTab: tab }),
  openMenu: () => set({ isMenuOpen: true }),
  closeMenu: () => set({ isMenuOpen: false }),
  toggleMenu: () => set((s) => ({ isMenuOpen: !s.isMenuOpen })),
  addToast: (toast) =>
    set((s) => ({
      toasts: [...s.toasts, { id: crypto.randomUUID(), ...toast }],
    })),
  removeToast: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

export const uiStoreInitialState = {
  activeTab: 'feed',
  isMenuOpen: false,
  toasts: [],
};
